import { defineStore } from 'pinia';
import { useApi } from '@/lib/api';
import { useGlobalStore } from '@/store/global-store-base';
import { useDestinations } from '@/store/destinations';
import { useSelectedDestination } from '@/store/selected-destination';
import { useUser } from '@/store/user';

export const useInPriceConfigs = defineStore('inPriceConfigs', () => {
  const api = useApi();

  const globalStoreBase = useGlobalStore({
    load: api.inPriceConfig_GetAll,
    dto: 'InPriceConfigDto',
    update: api.inPriceConfig_UpdateInPriceConfig,
    delete: api.inPriceConfig_DeleteInPriceConfig,
    signalR: 'InPriceConfigUpdate',
  });

  const { loaded } = globalStoreBase;

  /**
   * Config at exactly (season, destination) — NO fallback of any kind (a season without an in-price
   * config deliberately has none; never fall across destinations). Undefined destination resolves to
   * the default destination.
   */
  const getBySeasonAndDestination = (seasonId?: number | null, destinationId?: number) => {
    const seasonIdOrNull = seasonId ?? null;
    const resolvedDestinationId = destinationId ?? useDestinations().defaultDestination?.id;
    return loaded.value.find(
      (config) => config.seasonId == seasonIdOrNull && config.destinationId === resolvedDestinationId
    );
  };

  /** Selected-destination resolution (the market the user is working in) — for read-only summaries/teasers. */
  const getBySeasonId = (seasonId?: number | null) =>
    getBySeasonAndDestination(seasonId, useSelectedDestination().selectedDestination?.id);

  /** What deleting these steps (or the configs holding them) would clear. */
  const stepUsage = (stepIds: number[]) => api.inPriceConfig_GetStepUsage(useUser().brandId, stepIds);

  return {
    ...globalStoreBase,
    stepUsage,
    getBySeasonId,
    getBySeasonAndDestination,
  };
});
